/**
 * Level fallback mapping configuration
 * See https://confluence.collaboration-man.com/spaces/MANWS/pages/359773463/Affected+Products+for+Evergreen+Migration
 */
const fallbackToLevel14 = { '10': '14', '15': '14' };
const fallbackToLevels14And24 = { ...fallbackToLevel14, '20': '24', '25': '24' };

const fallbackConfig: Record<string, Record<string, string>> = {
    'man-sku00000005': fallbackToLevel14,
    'rio-sku00000027': fallbackToLevel14,
    'rio-sku00000047': fallbackToLevel14,
    'man-sku00000049': fallbackToLevel14,
    'man-sku00000050': fallbackToLevels14And24,
    'rio-sku00000055': fallbackToLevel14,
    'rio-sku00000056': fallbackToLevel14,
    'man-sku00000066': fallbackToLevel14,
    'man-sku00000073': fallbackToLevels14And24,
    'man-sku00000085': fallbackToLevel14,
    'rio-sku00000096': fallbackToLevel14,
    'man-sku00000098': fallbackToLevel14,
};

/**
 * Returns the fallback level for a given product and level combination if fallback is enabled.
 * If fallback is disabled or no mapping exists, returns the original level.
 *
 * @param productId - The product SKU ID (case-insensitive)
 * @param level - The requested level
 * @param fallbackEnabled - Whether the fallback feature is enabled
 * @returns The fallback level or the original level
 */
export function getFallbackLevel(
    productId: string,
    level: string | undefined,
    fallbackEnabled: boolean
): string | undefined {
    if (!fallbackEnabled || !level) {
        return level;
    }

    const normalizedProductId = productId.toLowerCase();
    const productFallback = fallbackConfig[normalizedProductId];
    if (!productFallback) {
        return level;
    }

    return productFallback[level] ?? level;
}
